import { render } from "./VendorWithdrawalsIndexTable.vue?vue&type=template&id=06f2c38c"
import script from "./VendorWithdrawalsIndexTable.vue?vue&type=script&lang=js"
export * from "./VendorWithdrawalsIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__